export const LanguageEnum = Object.freeze({
    ENGLISH: 'ENGLISH',
    GERMAN: 'GERMAN',
    // FRENCH: 'FRENCH',
    ITALIAN: 'ITALIAN',
    CZECH: 'CZECH',
    // GREEK: 'GREEK',
    // SPANISH: 'SPANISH'
})
